import type { MessagingSendMessage201AllOfOnezeroMedia } from './messagingSendMessage201AllOfOnezeroMedia';

export type MessagingSendMessage201AllOfOnezero = {
  /** 미디어 정보 */
  media?: MessagingSendMessage201AllOfOnezeroMedia;
};
